import axios from 'axios';
import {
  CURRENT_ORGANIZATION_DASHBOARD_URL,
  CURRENT_ORGANIZATION_PROJECTS_URL,
  CURRENT_ORGANIZATION_URL,
  CURRENT_ORGANIZATION_USERS_URL,
  ORGANIZATION_SIGNUP_URL,
  get_request_config,
} from '@/utils/system_constants/constant.js';
import { is_real_organization } from '@/utils/auth/session_constants.js';
import { parse_response_data } from '@/utils/api_response_helpers';

function unwrap_data(response) {
  const parsed = parse_response_data(response);
  return parsed?.data ?? parsed;
}

export async function fetch_current_organization() {
  const response = await axios.get(CURRENT_ORGANIZATION_URL, get_request_config());
  return unwrap_data(response);
}

export async function fetch_organization_dashboard() {
  const response = await axios.get(CURRENT_ORGANIZATION_DASHBOARD_URL, get_request_config());
  return unwrap_data(response);
}

export async function fetch_organization_users() {
  const response = await axios.get(CURRENT_ORGANIZATION_USERS_URL, get_request_config());
  return unwrap_data(response);
}

export async function fetch_organization_projects() {
  const response = await axios.get(CURRENT_ORGANIZATION_PROJECTS_URL, get_request_config());
  return unwrap_data(response);
}

export async function create_organization_project(payload) {
  const response = await axios.post(
    CURRENT_ORGANIZATION_PROJECTS_URL,
    payload,
    get_request_config()
  );
  return unwrap_data(response);
}

export function has_current_organization() {
  const raw_organization = sessionStorage.getItem('current_organization');

  if (!raw_organization) {
    return false;
  }

  return is_real_organization(parse_response_data(raw_organization));
}

export async function signup_organization(payload) {
  const response = await axios.post(ORGANIZATION_SIGNUP_URL, payload, get_request_config());
  return parse_response_data(response);
}
